import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export async function fetchProducts(params = {}) {
  const res = await client.get("/products", { params });
  return res.data;
}

export async function fetchProduct(id) {
  const res = await client.get(`/products/${id}`);
  return res.data;
}

export async function submitApplication(payload) {
  const res = await client.post("/applications", payload);
  return res.data;
}

export async function listApplications() {
  const res = await client.get("/admin/applications");
  return res.data;
}

export async function fetchMakers(params = {}) {
  const res = await client.get("/makers", { params });
  return res.data;
}

export async function fetchMaker(slug) {
  const res = await client.get(`/makers/${slug}`);
  return res.data;
}

export async function submitTradeInquiry(payload) {
  const res = await client.post("/trade-inquiries", payload);
  return res.data;
}

export async function submitPartnership(payload) {
  const res = await client.post("/partnerships", payload);
  return res.data;
}
